import * as React from "react"
const AcuteIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#fff"
        d="M15 20c-2.233 0-4.125-.775-5.675-2.325C7.775 16.125 7 14.233 7 12c0-2.217.775-4.104 2.325-5.662C10.875 4.779 12.767 4 15 4c2.217 0 4.104.78 5.663 2.338C22.22 7.896 23 9.783 23 12c0 2.233-.78 4.125-2.337 5.675C19.104 19.225 17.216 20 15 20Zm2.275-4.275L18.7 14.3 16 11.6V8h-2v4.425l3.275 3.3ZM2 9V7h4v2H2Zm-1 4v-2h5v2H1Zm1 4v-2h4v2H2Z"
      />
    </g>
  </svg>
)
export default AcuteIcon
